var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10636 27.4152C20.1517 8.22456 8.33931 1.1423 1.05248 0H100V70.8227C83.8923 59.3997 63.1823 55.9728 48.2252 66.2535C35.4984 75.0012 19.4613 77.6765 9.10636 70.8227C-1.2486 63.9689 -4.70026 51.4035 9.10636 27.4152Z",
    fill: "#92131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.2dc7ee5e552b24b0be859325b001b71c.svg";
export { ForwardRef as ReactComponent };